import React from "react";
import { DragSource, DropTarget } from 'react-dnd';
import withDragDropContext from "Pub/js/withDragDropContext";
import "./index.less";
@DragSource('DropdownItem', {
    beginDrag(props, monitor, component) {
        return props.item;
    },
    canDrag(props) {
        return !props.item.disabled;
    },
}, (connect, monitor) => ({
    connectDragSource: connect.dragSource(),
    isDragging: monitor.isDragging(),
}))
@DropTarget('DropdownItem', {
    drop(props, monitor, component) {
        const { item: dropItem, onDragDropChange } = props;
        if (dropItem.dropActive) {
            const dragItem = monitor.getItem();
            onDragDropChange({ dragItem, dropItem });
        }
    },
    canDrop(props, monitor) {
        return true;
    },
    hover(props, monitor, component) {
        const dropTarget = component.dropDownItemRef;
        const dragItem = monitor.getItem();
        const { item: dropItem } = props;
        // Don't replace items with themselves
        if (dragItem === dropItem) {
            return;
        }

        // Determine rectangle on screen
        const hoverBoundingRect = dropTarget.getBoundingClientRect();
        // Get vertical middle
        const hoverMiddleY = (hoverBoundingRect.bottom - hoverBoundingRect.top) / 2;
        // Determine mouse position
        const clientOffset = monitor.getClientOffset();
        // Get pixels to the top
        const hoverClientY = clientOffset.y - hoverBoundingRect.top;

        const differenceOffset = monitor.getDifferenceFromInitialOffset();
        if (differenceOffset.y < 0 && clientOffset.y < hoverBoundingRect.bottom) { // 上移
            component.updateDropActive('up');
        }
        if (differenceOffset.y > 0 && clientOffset.y > hoverBoundingRect.top) { // 下移
            component.updateDropActive('down');
        }
    },
}, (connect, monitor) => {
    return {
        connectDropTarget: connect.dropTarget(),
        canDrop: monitor.canDrop(),
        isOver: monitor.isOver(),
    };
})
class DragDropItem extends React.Component {
    constructor(props) {
        super(props);
        this.dropDownItemRef = null;
    }

    componentDidUpdate(prevProps) {
        const { isOver: prevOver } = prevProps;
        const { isOver: currentOver, item } = this.props;
        if (prevOver && !currentOver) { // 离开
            if (item.dropActive) {
                this.updateDropActive();
            }
        }
    }

    // 更新拖拽放置元素激活状态
    updateDropActive(dropActive) {
        const { item } = this.props;
        if (item.dropActive === dropActive) {return;}
        if (!dropActive) {
            delete item.dropActive;
        } else {
            item.dropActive = dropActive;
        }
        this.forceUpdate();
    }

    renderBorder() {
        const { item, placeholderLineStyle = '1px solid red' } = this.props;
        let borderClass = '';
        const borderTop = item.dropActive === 'up';
        const borderBottom = item.dropActive === 'down';
        if (borderTop) {
            borderClass = 'border-top'
        }
        if (borderBottom) {
            borderClass = 'border-bottom'
        }
        return <div
            className={borderClass}
            style={{
                borderTop: borderTop ? placeholderLineStyle : '',
                borderBottom: borderBottom ? placeholderLineStyle : '',
            }}></div>;
    }

    render() {
        const { connectDropTarget, connectDragSource, onClick = () => { }, className, children } = this.props;
        return connectDropTarget(connectDragSource(
            <div
                ref={e => { this.dropDownItemRef = e; }}
                className={`drag-drop-item ${className || ''}`}
                onClick={onClick}
            >
                {this.renderBorder()}
                {children}
            </div>,
        ));
    }
}

export default withDragDropContext(DragDropItem);